// extracted by mini-css-extract-plugin
module.exports = {"profile-collapse-section":"profile-collapse-section___2oUQC","section-data":"section-data___2WxtM","forgot-pass":"forgot-pass___21BGF","orange-icon":"orange-icon___Nef-q"};